// extracted by mini-css-extract-plugin
export default {"pagination":"L_n4Xy","page":"LNh5SR","active":"xwOI7Z","pageLink":"PtxlzX","arrowLink":"EfQv3N"};